/**
 * Action types for devices.
 *
 * Maps numeric action type identifiers to their corresponding string descriptions.
 *
 * @type {Object.<number, string>}
 * @property {string} 1 - Represents the "Unlocked" action type.
 * @property {string} 2 - Represents the "Locked" action type.
 */
export const ACTIONS_LOCKERS = {
	1: {
		id: 1,
		action: 'Unlocked',
		description: 'Unlock the device'
	},
	2: {
		id: 2,
		action: 'Locked',
		description: 'Lock the device'
	}
};
